import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { successOnboardActions } from './success-onboard.actions';
import { LocalStorageService } from '@fitup-monorepo/core/lib/services/local-storage.service';
import { challengeIdToJoinKey } from '@fitup-monorepo/core/lib/guards/join-challenge.guard';

export const successOnboardGuard: CanActivateFn = async (): Promise<boolean> => {
  const store = inject(Store);
  const localStorageService = inject(LocalStorageService);

  const challengeId: number = await localStorageService.retrieve(challengeIdToJoinKey);

  if (challengeId) {
    store.dispatch(successOnboardActions.loadAndJoinChallenge({ challengeId }));
  }

  return true;
};
